import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';

const baseUrl = new APISettings().getApiURL();

class DocumentTypeFilingActionApi extends BaseAPI {
    public getById: (documentTypeId: number) => Promise<any> = async (documentTypeId: number) => {
        return (await BaseAPI.axios.get(`${baseUrl}/DocumentTypeFilingAction/GetFilingActionsByDocumentTypeId/${documentTypeId}`)).data.output;
    };
}

export const documentTypeFilingActionApi = new DocumentTypeFilingActionApi();